module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/banner-mobile.1d18f595.png";